import { InlineStack } from '@customerio/pluma-components/react';
import { sanitizeHtml } from '@/utils/sanitize';
import { isEmptyString } from '@/utils/string';
import * as styles from './delivery-message-preview.css';

type SmsMessagePreviewProps = {
  body: string;
  /** Where the bubble sits in its row. The delivery preview centers it; a message thread aligns it to the sender's side. */
  alignInline?: 'center' | 'flex-start' | 'flex-end';
};

/**
 * SMS / Twilio message-body bubble. Two richer Ember layouts are deferred (FPS-3194): the
 * Twilio content-template card (header/media/actions parsed from a
 * `contentTemplateId` body) and the Design-Studio `<x-sms>` body, which needs a
 * server render endpoint that isn't in the data layer yet. Plain message bodies
 * render faithfully; a content-template body degrades to its sanitized text.
 */
export function SmsMessagePreview({ body, alignInline = 'center' }: SmsMessagePreviewProps) {
  const content = isEmptyString(body) ? '…' : sanitizeHtml(body);

  return (
    <InlineStack alignInline={alignInline}>
      <div className={`${styles.smsBubble} fs-mask`} data-test-delivery-preview-sms>
        {/* nosemgrep: react-dangerouslysetinnerhtml — content is sanitized via DOMPurify in sanitizeHtml() */}
        <span dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </InlineStack>
  );
}
